import React from "react";
import { makeStyles, Avatar as MaterialAvatar } from "@material-ui/core";

interface AvatarProps {
  src: string;
  alt?: string;
  size?: number,
}

const useStyles = makeStyles(
  (theme) => ({
    avatar: {
      width: (props: AvatarProps) => props.size != undefined ? props.size : 54,
      height: (props: AvatarProps) => props.size != undefined ? props.size : 54,
    },
  }),
  { name: "avatar-badge-styles" }
);

export default function Avatar(props: AvatarProps) {
  const classes = useStyles(props);
  // Props
  const { src, alt } = props;

  return (
    <MaterialAvatar alt={alt} src={src} className={classes.avatar}>
      {alt}
    </MaterialAvatar>
  );
}
